import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { type Navigation } from '@models/Navigation';
import { type Maybe } from '@models/Maybe';
import { getMenuContent } from '@utils/getMenuContent';
import { useGlobalData } from './GlobalDataContext';

interface UseMenuContext {
    menuContent: Maybe<Navigation>;
}

export function useMenuContext(): UseMenuContext {
    const { pid } = useParams();
    const { systemsQuery, craCount } = useGlobalData();

    const menuContent = useMemo(() => {
        return getMenuContent(pid, systemsQuery.nodes, craCount);
    }, [pid, systemsQuery.nodes, craCount]);

    return { menuContent };
}
